import BaIcon from './ba-icon.vue';

export default BaIcon;

export {
  BaIcon,
};
